import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-height-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './height-page.component.html',
    styleUrl: './height-page.component.css',
})
export default class HeightPageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Altezza';
    chartLabel = 'Altezza';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'line',
        [HealthChartPeriod.month]: 'line',
    };
    supportedPeriods: HealthChartPeriod[] = [HealthChartPeriod.week, HealthChartPeriod.month];
    heightHealthDataType = HealthDataType.HEIGHT;
    hasTwoDecimals = false;
    payloadTypes: dataType[] = ['body'];
    canAddHealthData = true;

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
